import { HttpResponseBase } from '@angular/common/http';
import { saveAs } from 'file-saver';

/**
 * Saves a file by opening file-save-as dialog in the browser
 * using file-save library.
 * @param blobContent file content as a Blob
 * @param fileName name file should be saved as
 */
export const saveFile = (blobContent: Blob, fileName: string) => {
   const blob = new Blob([blobContent], { type: 'application/octet-stream' });
   saveAs(blob, fileName);
};

/**
* Derives file name from the http response
* by looking inside content-disposition
* @param res http Response
*/
export const getFileNameFromResponseContentDisposition = (res: HttpResponseBase) => {
   const contentDisposition = res.headers.get('content-disposition') || '';
   const matches = /filename=([^;]+)/ig.exec(contentDisposition);
   const fileName = (matches[1] || 'untitled').replace(/['"]+/g, '').trim();
   return fileName;
};
